import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import {
  useSetIsScanEnabledSceneMutation,
  useIsScanEnabledInSceneLazyQuery,
} from '../../generated/graphql';
import { useRouter } from 'next/router';
import styles from '../text-chat/text-chat.module.css';

export default function ScanScene() {
  const router = useRouter();
  const [switchEnableScanM] = useSetIsScanEnabledSceneMutation();
  const [isEnabled] = useIsScanEnabledInSceneLazyQuery();
  const [isChecked, setIsChecked] = useState(false);

  const sceneId = Array.isArray(router.query?.id)
    ? router.query?.id[0]
    : router.query?.id;

  const fun = async () => {
    const { data } = await isEnabled({
      variables: {
        where: {
          id: sceneId as string,
        },
      },
    });

    const { enabled }: any = data?.isScanEnabledInScene;
    setIsChecked(() => enabled);
  };

  useEffect(() => {
    fun();
  }, []);

  async function switchEnableScan(checked: boolean) {
    setIsChecked(() => checked);

    await switchEnableScanM({
      variables: {
        where: {
          id: sceneId as string,
          enabled: checked,
        },
      },
    });
  }

  return (
    <div>
      <span className={styles.title}>Scan</span>
      <div>
        <span className={styles.subtitle}>
          You can activate / deactivate the Scan Model with this switch
        </span>
      </div>
      <Switch
        onChange={switchEnableScan}
        checked={isChecked}
        checkedChildren='Enabled'
        unCheckedChildren='Disabled'
      />
    </div>
  );
}
